export default class ClaimFile {
    constructor() {
        this.id;
        this.claimId;
        this.fileId;
        this.claimFileType;
        this.validUntil;
        this.isVerified;
        this.verifiedByUserId;
        this.verfiedByUser;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.claimId = setEntity.claimId;
        this.fileId = setEntity.fileId;
        this.claimFileType = setEntity.claimFileType;
        this.validUntil = setEntity.validUntil;
        this.isVerified = setEntity.isVerified;
        this.verifiedByUserId = setEntity.verifiedByUserId;
        this.verfiedByUser = setEntity.verfiedByUser;
        return this;
    }
}
